/// <reference path="irep.js"/>

IREP.activityMonitor = (function () {
	var init = function () {
		var hub = $.connection.activityMonitor
		hub.client.connected = function (id, date) { };
		hub.client.disconnected = function (id, date) { };
		$.connection.hub.qs = { paxuid: IREP.options.user.currentUID }
		$.connection.hub.start().done(function () {
			hub.server.startTrainingTime(urlParam('code'));
		});
	};

	var urlParam = function (name) {
		var results = new RegExp('[\?&]' + name + '=([^&#]*)', 'i').exec(window.location.href);
		if (results == null) {
			return null;
		}
		else {
			return decodeURI(results[1]) || 0;
		}
	}

	return {
		init: init
	};
})();